import { Component, OnDestroy, Inject } from "@angular/core";
import { GAME_ENGINE } from "./service-tokens";
var AppMainComponent = (function () {
    function AppMainComponent(game_engine_) {
        this.game_engine_ = game_engine_;
    }
    ;
    AppMainComponent.prototype.ngOnDestroy = function () {
        this.game_engine_.terminate();
    };
    ;
    AppMainComponent.decorators = [
        { type: Component, args: [{
                    selector: "app-main",
                    template: "\n    <main-canvas></main-canvas>\n    "
                },] },
    ];
    AppMainComponent.ctorParameters = function () { return [
        { type: Worker, decorators: [{ type: Inject, args: [GAME_ENGINE,] },] },
    ]; };
    return AppMainComponent;
}());
export { AppMainComponent };
//# sourceMappingURL=app-main.component.js.map